import { FC } from 'react';

export const Ticket: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 2C6.44772 2 6 2.44772 6 3V21C6 21.5523 6.44772 22 7 22H17C17.5523 22 18 21.5523 18 21V3C18 2.44772 17.5523 2 17 2H7ZM4 3C4 1.34315 5.34315 0 7 0H17C18.6569 0 20 1.34315 20 3V21C20 22.6569 18.6569 24 17 24H7C5.34315 24 4 22.6569 4 21V3Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9 0C8.44772 0 8 0.447715 8 1C8 1.55228 8.44772 2 9 2H15C15.5523 2 16 1.55228 16 1C16 0.447715 15.5523 0 15 0H9Z"
			fill="currentColor"
		/>
		<circle cx="12" cy="1" r="0.5" fill="currentColor" />
		<circle cx="9" cy="7" r="1.5" fill="currentColor" />
		<rect x="11.5" y="6.5" width="5" height="1" rx="0.5" fill="currentColor" />
		<circle cx="9" cy="11" r="1.5" fill="currentColor" />
		<rect x="11.5" y="10.5" width="5" height="1" rx="0.5" fill="currentColor" />
		<circle cx="9" cy="15" r="1.5" fill="none" stroke="currentColor" strokeWidth="1" />
		<rect x="11.5" y="14.5" width="5" height="1" rx="0.5" fill="currentColor" />
	</svg>
);
